<div class="relative flex h-full w-full flex-col">
    <!-- Content -->
    <div
        class="flex flex-auto flex-col items-center p-8 pb-6 sm:flex-row sm:items-start sm:pb-8"
    >
        <!-- Icon -->
        <div
            class="flex h-10 w-10 flex-0 items-center justify-center rounded-full bg-warn-100 text-warn-600 dark:bg-warn-600 dark:text-warn-50 sm:mr-4"
        >
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:exclamation-triangle'"
            ></mat-icon>
        </div>

        <div
            class="mt-4 flex flex-col items-center space-y-1 text-center sm:mt-0 sm:items-start sm:pr-8 sm:text-left"
        >
            <!-- Title -->
            <div class="text-xl font-medium leading-6">
                {{ 's.alert.header.sessionExpired' | transloco }}
            </div>

            <!-- Message -->
            <div class="text-secondary">
                {{ 's.alert.msg.sessionCouldNotRenew' | transloco }}
            </div>

            <!-- Countdown -->
            <div class="text-secondary">
                {{
                    's.alert.msg.sessionLogoutIn'
                        | transloco: { countdown: countdown }
                }}
            </div>
        </div>
    </div>

    <!-- Actions -->
    <div
        class="flex items-center justify-center space-x-3 bg-gray-50 px-6 py-4 dark:bg-black dark:bg-opacity-10 sm:justify-end"
    >
        <button mat-flat-button [color]="'warn'" (click)="logout()">
            {{ 's.btn.reLogin' | transloco }}
        </button>
    </div>
</div>
